export const formatMDY = (isoString: string | undefined): string => {
    if (!isoString) return '';

    try {
        const date = new Date(isoString);
        
        // Use local date parts to avoid timezone issues unless you specifically want UTC
        const month = date.getMonth() + 1; // getMonth() is 0-indexed
        const day = date.getDate();
        const year = date.getFullYear();

        // Template literal to format as M/D/YYYY
        return `${month}/${day}/${year}`;
    } catch (error) {
        console.error("Error formatting date:", error);
        return isoString; // Return original value on failure
    }
};